export const handlePendingChangesNavigation = (app, handleClick, vclContext = {}) => {
	const {
		handleSave: handleSaveVCL,
		handleDiscardChanges: handleDiscardChangesVCL,
		isSaving: isSavingVCL,
		hasChanges: hasChangesVCL,
	} = vclContext;

	if (app.hasPendingChanges()) {
		const noSaveCB = () => {
			return handleClick();
		};
		const saveCB = () => {
			app.saveDataAndCloseModal('IGNORE', handleClick);
		};

		app.openPendingChangesModal('content', noSaveCB, saveCB);
	} else if (app.hasPendingSlideshowChanges()) {
		const noSaveCB = () => {
			return handleClick();
		};
		const saveCB = () => {
			app.saveDataAndCloseModal('IGNORE', handleClick);
		};

		app.openPendingChangesModal('content', noSaveCB, saveCB);
	} else if (app.hasPendingPromises()) {
		const noSaveCB = () => {
			return handleClick();
		};
		const saveCB = () => {
			app.saveDataAndCloseModal('IGNORE', handleClick);
		};

		app.openPendingChangesModal('content', noSaveCB, saveCB);
	} else if (hasChangesVCL && !isSavingVCL) {
		const noSaveCB = () => {
			handleDiscardChangesVCL();
			return handleClick();
		};
		const saveCB = () => {
			handleSaveVCL().catch((error) => {
				alert(error?.isSaveRefused ? error.message : 'Error saving changes. Please try again.');
			});
		};

		app.openPendingChangesModal('content', noSaveCB, saveCB);
	} else {
		handleClick();
	}
};